export const selectMobilePlanData = state => state.mobilePlan.data;
export const selectMobilePlanTitle = state => state.mobilePlan.data?.title;
